import React, { type DetailedHTMLProps, type HTMLAttributes, type ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import { SupChevronLeft, SupChevronRight } from "../../../../icons";
import { SupText } from "../../../../components/UI/Text";

import { isEqual } from "../utils";

interface GrabberProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  disabled?: boolean;
  currentValue: number;
  minValue: number;
  maxValue: number;
  epsilon: number;
  displayMax?: boolean;
  formatter: (value: number, { min, max }: { min: number; max: number }) => ReactNode;
}

export function GrabberWithValue(props: GrabberProps) {
  const { currentValue, minValue, maxValue, epsilon, disabled = false, className, formatter, displayMax = true, ...restProps } = props;

  return (
    <div {...restProps} className={twJoin("sup-slider-grabber", className, "w-0 h-px")}>
      <div
        tabIndex={0}
        className={twJoin(
          "absolute border-0.5 gap-px -translate-x-1/2 -translate-y-1/2 flex items-center rounded-full py-0.5 duration-200 bg-primary-50 text-neutral-900 border-primary-500",
          !disabled
            ? "hover:border-primary-700 hover:bg-primary-100 hover:font-bold focus:border focus:border-neutral-400 focus:bg-neutral-200 focus:font-bold [&:focus>span]:border active:bg-primary-200 active:border-primary-700 active:text-primary-800 [&:active>span]:font-bold"
            : ""
        )}
      >
        <SupChevronLeft width={12} height={12} className={currentValue !== minValue ? "opacity-100" : "opacity-0"} />
        <SupText as="span" variant="caption">
          {isEqual(currentValue, maxValue, { epsilon }) && displayMax ? "MAX" : formatter(currentValue, { min: minValue, max: maxValue })}
        </SupText>
        <SupChevronRight width={12} height={12} className={currentValue !== maxValue ? "opacity-100" : "opacity-0"} />
      </div>
    </div>
  );
}
